import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip, Textarea } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalView extends React.Component<Props> {
	
	render() {
		const item: any = this.props.item?.corporate_payment_quote?.corporate_payment;

		return (
			<div id="modal-view-corporate-payment">
				{
					item != null && (
						<div className="container-data">
							<p><strong>Fecha:</strong> { moment(item?.created_at).format('DD/MM/YYYY') }</p>
							<p><strong>Monto Pagado:</strong> { Globals.formatMiles(item?.amount) }</p>
							<p><strong>Forma de pago:</strong> { item?.payment_method?.name }</p>
							<p><strong>Foto adjunta:</strong> { item?.photo ? (
								<React.Fragment>
									<a href={ Constants.BASE_STORAGE + item?.photo } target="_blank">Ver</a>
								</React.Fragment>
							) : (
								<React.Fragment>
									-
								</React.Fragment>
							) }</p>
							{
								item?.comments && (
									<Textarea
										disabled={ true }
										rows={ 3 }
										placeholder="Observaciones (Opcional)"
										name="comments"
										onChange={ () => {} }
					                    value={ item?.comments } />
								)
							}
						</div>
					)
				}
			</div>
		)
	}
}

export default ModalView;